import ClickToCallModal from './ClickToCallModal';
import './style.css';

export default ClickToCallModal;
